module.exports = __webpack_public_path__ + "static/mockup3-10cb292fe2948faed87b6a7e64381041.png";